function initialize() {
    $('.btn-footer-arrow-up').on('click', function () {
        $('html, body').animate(
            {
                scrollTop: 0,
            },
            500
        );
    });
}

initialize();
